import React from "react"
import { AcceptsItemsList } from "./types"

/**
 * Renders a child component with items list, but only for custom components (not DOM elements)
 * This prevents passing itemsList to native DOM elements
 */
export const renderChildWithItems = (
  child: React.ReactElement,
  items: any[],
): React.ReactElement => {
  // Only pass itemsList prop to custom components (not DOM elements)
  if (
    typeof child.type !== "string" && // Check if it's not a DOM element
    (typeof child.type === "function" ||
      (child.type && typeof child.type === "object"))
  ) {
    // Filter out ref to prevent passing it to function components
    const { ref, ...propsWithoutRef } = child.props
    return React.cloneElement(child, {
      ...propsWithoutRef,
      itemsList: items,
    } as Partial<AcceptsItemsList>)
  }
  return child
}
